<template>
    <ac-modal :title="'Edit Amount'" :size-class="'modal-md'" ref="nachaRowEditorModal">
        <div v-if="canEditBatch">
            <div class="form-group">
                <label>Amount</label>
                <input type="text" class="form-control " v-model="amount" />
            </div>
            <div style="text-align: right;">
                <ac-button class="btn btn-green btn-sm" :action="saveModal">SAVE AMOUNT</ac-button>
                <ac-button class="btn btn-red btn-sm" :action="closeModal">CLOSE</ac-button>
            </div>
        </div>
        <div v-else>
            Unable to edit past amounts.
        </div>
    </ac-modal>
</template>

<script>
    import AcModal from "../../../../../global/customHtmlElements/AcModal.vue";
    import {api} from "../../../../../global/framework/api.js";
    import {common} from "../../../../../global/common.js";

    export default {
        name: "NachaRowEditorModal",
        components: {AcModal},
        data() {
            return {
                canEditBatch: false,
                batchId: 0,
                amount: 0,
            };
        },
        methods: {
            async showModal({batchId, amount}) {
                this.canEditBatch = false;
                this.batchId = batchId;
                this.amount = amount;
                // console.log("NachaRowEditorModal getAchFiles batchId, amount: ", batchId, amount);
                this.canEditBatch = await api.getDataById('PaymentReport', this.batchId, 'CanEditBatch');
                this.$refs.nachaRowEditorModal.open();
            },
            async saveModal() {
                // console.log("NachaRowEditorModal saveModal amount: ", this.amount);
                this.$emit('nachaRowSaved', this.amount);
                this.closeModal();
            },
            closeModal() {
                this.$refs.nachaRowEditorModal.close();
            },
        }
    }
</script>

<style scoped>
    strong {
        font-weight: bold !important;
    }
</style>